/* @ngInject */
function ShareArtButtonController ($rootScope, $scope, $state, $q, $timeout, ArtsService, AssetPreviewService, ToastService, CustomerConfigurationsService, UdsModalService, SocialMediaService) {
  const getShareArtDialogController = () => $q.when(import('../../../arts/dialogs/share-art/share-art-dialog.controller'))
  const getSocialMediaLinkAccountDialogController = () => $q.when(import('../../../arts/dialogs/social-media-link-account/social-media-link-account.controller'))

  const api = {
    getShareArtDialogController,
    getSocialMediaLinkAccountDialogController,
    _openSocialMediaLinkAccountDialog,
    _goToSocialMediaPage
  }
  this.getApi = () => api

  activate()

  function activate () {}

  $scope.handleShareClick = (selectedTab) => {
    if (selectedTab === 'socialMedia') {
      const hasNotUserAccounts = !$rootScope?.oUser?.socialAccounts?.length

      if (hasNotUserAccounts) {
        return api._openSocialMediaLinkAccountDialog()
      }

      AssetPreviewService.closePreview()

      if ($scope.onSaveArt) {
        return $scope.onSaveArt(api._goToSocialMediaPage, false)
      }

      return api._goToSocialMediaPage()
    }

    if ($scope.location) {
      $scope.art.location = $scope.location
    }

    if ($scope.contextData) {
      $scope.art.contextData = $scope.contextData
    }

    const defaultOnClose = () => {}

    api.getShareArtDialogController().then(({ ShareArtDialogController }) => {
      const shareArtDialog = UdsModalService.createModal({
        controller: ShareArtDialogController,
        modalName: 'shareArtDialog',
        data: {
          selectedTab,
          art: $scope.art
        },
        onClose: $scope.onClose || defaultOnClose
      })

      shareArtDialog.open()
    })
  }

  $scope.showSocialMediaButton = (template) => {
    const isUser = $rootScope.isUser()
    const hasUserAccounts = $rootScope?.oUser?.socialAccounts?.length
    const isEnableSocialMedia = $rootScope.isEnableSocialMedia
    const isEditor = $scope.isEditor

    return SocialMediaService.showSocialButton(template, isUser, isEnableSocialMedia, isEditor) && hasUserAccounts
  }

  function _openSocialMediaLinkAccountDialog () {
    api.getSocialMediaLinkAccountDialogController().then(({ SocialMediaLinkAccountController }) => {
      const socialMediaLinkedDialog = UdsModalService.createModal({
        controller: SocialMediaLinkAccountController,
        modalName: 'socialMediaLinkAccountDialog'
      })

      socialMediaLinkedDialog.open()
    })
  }

  function _goToSocialMediaPage () {
    const templateId = $scope.art.id

    return $state.go('arts.socialMedia', {
      templateIds: [templateId]
    })
  }
}

export { ShareArtButtonController }
